export default "__VITE_ASSET__DXsh9qK9__"